import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
export class ApiService {
constructor() {
    }
/**
 * @param {?} body
 * @return {?}
 */
findAreaList(body): Observable<any> {
        return null;
    }
/**
 * @param {?} body
 * @return {?}
 */
getAreaByCode(body): Observable<any> {
        return null;
    }
/**
 * 地址-根据name获取分页地址
 * @param {?} body
 * @return {?}
 */
getAreaPage(body): Observable<any> {
        return null;
    }
/**
 * @param {?} formData
 * @return {?}
 */
upload(formData: FormData): Observable<any> {
        return null;
    }
/**
 * 提货地址
 * @param {?} body
 * @return {?}
 */
getPickAddr(body: any): Observable<any> {
        return null;
    }
/**
 * 客户品名
 * @param {?} body
 * @return {?}
 */
getCustomerGood(body:any): Observable<any> {
        return null;
    }
/**
 * 客户品名及套餐集合
 * @param {?} body
 * @return {?}
 */
getComboAndCustomerGood(body:any): Observable<any> {
        return null;
    }
/**
 * 标准品名
 * @param {?} body
 * @return {?}
 */
getStandarGood(body:any): Observable<any> {
        return null;
    }
/**
 * 发货人
 * @param {?} body
 * @return {?}
 */
getConsignorList(body:any): Observable<any> {
        return null;
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ApiService_tsickle_Closure_declarations() {
/** @type {?} */
ApiService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ApiService.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
